import { useTranslation } from "react-i18next";
import { Item } from "@tellescope/design-system";
import { cn, formatFileSize } from "@tellescope/utils";
import { FileUploadedItemPreview } from "../FileUploadedItemPreview";

interface ExistingFilePickerRowProps {
  name: string;
  secureName: string;
  type?: string;
  size: number;
  timestamp?: Date;
  isSelected: boolean;
  onSelect: () => void;
}

export const ExistingFilePickerRow = ({
  name,
  secureName,
  type,
  size,
  timestamp,
  isSelected,
  onSelect,
}: ExistingFilePickerRowProps) => {
  const { t, i18n } = useTranslation("forms");

  return (
    <Item
      variant="selectable"
      size="sm"
      onClick={onSelect}
      aria-pressed={isSelected}
      className={cn("mb-1", isSelected && "border-primary bg-muted/50")}
    >
      <Item.Media className="self-center translate-y-0">
        <FileUploadedItemPreview name={name} secureName={secureName} type={type} />
      </Item.Media>
      <Item.Content className="gap-0.5">
        <Item.Title>{name}</Item.Title>
        <Item.Description className="line-clamp-1 text-xs">
          {timestamp
            ? t("{{size}} · uploaded {{date}}", {
                size: formatFileSize(size),
                date: timestamp.toLocaleDateString(i18n.language),
              })
            : formatFileSize(size)}
        </Item.Description>
      </Item.Content>
    </Item>
  );
};
